import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/org-chart-structures', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/org-chart-structures', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/org-chart-structures/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/org-chart-structures/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/org-chart-structures/${id}`).then(response => Promise.resolve(response.data))
}

export default { get, store, find, update, destroy }
